import axios from '@/plugins/axios';
import { ExternalUserProfileUserSkills, SkillListItem } from '@/models/Profile';
import { UserCarouselUser } from '@/views/public/landingpage/components/user-carousel/userCarousel.types';

const LANDINGPAGE_USERS_RANDOM_ENDPOINT = '/v1/landingpage/users/random';
const DEFAULT_MAX_RESULTS = 25;
const DEFAULT_MIN_SKILLS = 3;

interface ExternalLandingpageUser {
  profilesummary?: string;
  skillList?: ExternalUserProfileUserSkills;
  imageData?: string;
  imageType?: string;
}

const hasRenderableAvatar = (user: ExternalLandingpageUser): boolean => (
  Boolean(user.imageData && user.imageType)
);

const sortSkillsByPosition = (skills: SkillListItem[] = []) => (
  [...skills].sort((a, b) => ((a as any).position ?? 0) - ((b as any).position ?? 0))
);

const mapSkills = (skillList?: ExternalUserProfileUserSkills): SkillListItem[] => {
  const rawSkills = skillList?.userSkillList ?? [];
  return sortSkillsByPosition(rawSkills as SkillListItem[]);
};

const mapAvatarSrc = (user: ExternalLandingpageUser): string => {
  if (!user.imageData || !user.imageType) {
    return '';
  }

  return `data:${user.imageType};base64,${user.imageData}`;
};

const mapLandingpageUser = (user: ExternalLandingpageUser, index: number): UserCarouselUser => ({
  id: user.skillList?.userSkillList?.[0]?.userSkillId ?? `landingpage-user-${index}`,
  avatarSrc: mapAvatarSrc(user),
  summary: user.profilesummary ?? '',
  skills: mapSkills(user.skillList)
});

export default {
  async getRandomLandingpageUsers(
    params: { maxResults?: number; minSkills?: number } = {}
  ): Promise<UserCarouselUser[]> {
    const { maxResults = DEFAULT_MAX_RESULTS, minSkills = DEFAULT_MIN_SKILLS } = params;
    /**
     * Open-API Description
     * GET /api/v1/landingpage/users/random
     */
    return axios.get<ExternalLandingpageUser[]>(LANDINGPAGE_USERS_RANDOM_ENDPOINT, {
      params: {
        maxResults,
        minSkills
      }
    }).then(({ data }) => data.filter(hasRenderableAvatar).map(mapLandingpageUser));
  }
};
